"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuotePromoDialog = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
require("../BaseQuoteTool/quoteTool.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var QuotePromoDialog = exports.QuotePromoDialog = function QuotePromoDialog(_ref) {
  var onPanelClose = _ref.onPanelClose,
    policyStartDate = _ref.policyStartDate;
  return /*#__PURE__*/_react["default"].createElement(_components.Panel, {
    type: "modal",
    modalLabel: "Promotion message",
    open: true,
    onClose: onPanelClose,
    size: "tiny",
    customCssClass: "quotePromoDialog",
    header: {
      fixed: true,
      content: 'Promotion message'
    },
    footer: {
      fixed: true,
      content: /*#__PURE__*/_react["default"].createElement("button", {
        className: "button primary",
        type: "button",
        onClick: onPanelClose
      }, "Close")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "promo-dialog-content"
  }, /*#__PURE__*/_react["default"].createElement("p", null, "The promotion code expires before ", policyStartDate, ". Your policy start date will be reverted."), /*#__PURE__*/_react["default"].createElement("p", null, "If you wish to start your policy on this day, you will need to remove the promotion code.")));
};
QuotePromoDialog.propTypes = {
  policyStartDate: _propTypes["default"].string,
  onPanelClose: _propTypes["default"].func
};